import * as types from '../types';

export default {
  [types.GET_LOCALUSER]: state => state.localUser,
  [types.GET_HOMEDATA]: state => state.homedata,
};



// WEBPACK FOOTER //
// ./src/store/asset/getters.js